module.exports = __webpack_public_path__ + "static/img/lx.c9245e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lx.jpg
// module id = lmF6
// module chunks = 11 14